import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../http-common";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isCompetitor, setIsCompetitor] = useState(false);
  const [isJury, setIsJury] = useState(false);
  const [isInternshipJury, setIsInternshipJury] = useState(false);
  const [isMentor, setIsMentor] = useState(false);
  const [isTrainee, setIsTrainee] = useState(false);
  const [isWinner, setIsWinner] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const navigate = useNavigate();

  const login = async (username, password) => {
    try {
      const response = await http.post(
        "/auth/login?username=" + username + "&password=" + password
      );
      const principal = {
        username: response.data.username,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        roleCode: response.data.roleCode,
        accessToken: response.data.accessToken,
      };
      setUser(principal);
      checkIsCompetitor(response.data.roleCode);
      setIsJury(response.data.roleCode === 204);
      setIsInternshipJury(response.data.roleCode === 209);
      setIsMentor(response.data.roleCode === 207);
      setIsTrainee(response.data.roleCode === 208);

      sessionStorage.setItem("principal", JSON.stringify(principal));
      let uri = "/admin/dashboard";
      if (response.data.roleCode === 201) {
        uri = "/admin/inicio";
      }
      if (response.data.roleCode === 207) {
        uri = "/admin/planos-de-negocio";
      }
      if (response.data.roleCode === 208) {
        uri = "/admin/painel-estagiario";
      }
      try {
        const response = await http.get(`/applications/phone/${username}`);
        setIsWinner(response.data.isWinner);
      } catch (error) {}

      navigate(uri);
    } catch (error) {
      toast.error("Número de telefone ou senha inválidos");
    }
  };

  const checkIsCompetitor = (roleCode) => {
    let result = roleCode === 201;
    setIsCompetitor(result);
    return result;
  };

  const logout = () => {
    setUser(null);
    setIsCompetitor(false);
    setIsWinner(false);
    setIsAdmin(false);
    sessionStorage.removeItem("principal");
    navigate("/adm");
  };

  useEffect(() => {
    const loggedUser = sessionStorage.getItem("principal");
    if (loggedUser) {
      const parsed = JSON.parse(loggedUser);
      setUser(parsed);
      checkIsCompetitor(parsed.roleCode);
      setIsJury(parsed.roleCode === 204);
      setIsInternshipJury(parsed.roleCode === 209);
      setIsMentor(parsed.roleCode === 207);
      setIsTrainee(parsed.roleCode === 208);
      setIsAdmin(parsed.roleCode === 200);
    }
    setLoading(false);
  }, []);
  return (
    <AuthContext.Provider
      value={{
        authenticated: !!user,
        user,
        isCompetitor,
        isJury,
        isInternshipJury,
        isMentor,
        isTrainee,
        isAdmin,
        login,
        logout,
        loading,
        isWinner,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
